import UtilsService from '../services/UtilsService';

class UtilsController {
  async copyToClipboard(text) {
    return await UtilsService.copyToClipboard(text);
  }

  downloadQRImage(qrCodeImage, eventTitle) {
    return UtilsService.downloadQRImage(qrCodeImage, eventTitle);
  }

  downloadFile(url, filename) {
    const result = UtilsService.downloadFile(url, filename);
    if (result.success) {
      UtilsService.showAlert(result.message, 'success');
    } else {
      UtilsService.showAlert(result.message, 'error');
    }
    return result;
  }

  showNotification(message, type = 'info') {
    UtilsService.showAlert(message, type);
  }
}

export default new UtilsController();